import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingButton } from '@mui/lab';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, TextField, Typography, } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useCallback, useState, } from 'react';
import { EmployeeApi } from '../api/baseApis';
import { CloseDialogButton } from '../components/CloseDialogButton';
import { environment } from '../environment';
import { useUser } from '../hooks/useUser';
export function RefreshAccountConfirmationDialog(props) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [confirmText, setConfirmText] = useState('');
    const [doesConfirmTextMatch, setDoesConfirmTextMatch] = useState(null);
    const resetText = 'RESET';
    const onConfirmTextChange = (event) => {
        setConfirmText(event.target.value.trim());
        if (event.target.value === resetText) {
            setDoesConfirmTextMatch(true);
        }
    };
    const handleClose = useCallback(() => {
        setConfirmText('');
        setDoesConfirmTextMatch(true);
        props.setShowDialog(false);
    }, [props]);
    const { userRefresh } = useUser(EmployeeApi);
    const onRefreshSuccess = () => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = environment.employeeFrontendUrl ?? window.origin;
    };
    const handleRefresh = useCallback(async () => {
        if (confirmText !== resetText) {
            setDoesConfirmTextMatch(false);
            return;
        }
        setDoesConfirmTextMatch(true);
        //TODO: Handle UI Scenario
        userRefresh().mutation(onRefreshSuccess);
    }, [userRefresh, confirmText]);
    return (_jsxs(Dialog, { fullScreen: fullScreen, open: props.showDialog, onClose: handleClose, "aria-labelledby": "refresh-account-title", children: [_jsx(DialogTitle, { id: "refresh-account-title", children: "Are you sure you want to reset your account?" }), _jsx(CloseDialogButton, { onClose: handleClose }), _jsx(DialogContent, { children: _jsx(DialogContentText, { children: _jsx(Typography, { variant: "body1", children: "Type \"RESET\" and confirm to reset your account settings and history. This cannot be undone. Your username and password will stay the same." }) }) }), _jsx(DialogActions, { children: _jsxs(Grid, { container: true, spacing: 6, justifyContent: 'center', alignItems: 'center', children: [_jsx(Grid, { item: true, xs: 11.5, children: _jsx(TextField, { label: 'Enter "RESET" to confirm', required: true, fullWidth: true, error: doesConfirmTextMatch !== null && !doesConfirmTextMatch, helperText: doesConfirmTextMatch !== null &&
                                    !doesConfirmTextMatch &&
                                    'Please type "RESET" in uppercase if you wish to reset your account', value: confirmText, onChange: onConfirmTextChange }) }), _jsxs(Grid, { item: true, xs: 12, display: 'flex', justifyContent: 'space-between', children: [_jsx(Button, { size: "small", onClick: handleClose, children: "Cancel" }), _jsx(LoadingButton, { variant: "contained", size: "small", color: "error", loading: userRefresh().isLoading, type: 'submit', onClick: handleRefresh, children: "Confirm" })] })] }) })] }));
}
